import { useNavigate } from "react-router-dom";
import AuthenMysa from "../../services/authen/mysa.authen";
import "./choose-company.component.scss";
import { useContext, useEffect, useState } from "react";
import { ProviderContext } from "../../contexts/provider.context";
import ProfileSCModel from "../../model/profile.model";
import tokenService from "../../services/token.service";
import { createCompany, getCompany, updateUser } from "../../services/api.service";
import storage from "../../utils/storage";
import LOGO from "../../assets/images/logo-interview-ai.png"
import Lottie from "lottie-react";
import LOADING from "../../assets/json/loading.json";
import ScoutConnectService from "../../services/hr9/hr9.services";

const ChooseCompanyComponent = () => {

    const navigate = useNavigate();
    const { setProfileModel }: any = useContext(ProviderContext);
    const [isLoading, setIsLoading] = useState(false);
    const [profileMod, setProfileMod] = useState<ProfileSCModel>();
    useEffect(() => {
        getAllCompany();

    }, [])
    const getAllCompany = async () => {
        try {
            const profileResult = await AuthenMysa().getProfile();
            if (profileResult) {

                const profileModels = profileResult["data"];
                setProfileMod(profileModels);
            } else {
                navigate("/login")
            }
        } catch {
            navigate("/login")
        }
    }

    const chooseCompany = (id) => {
        if (profileMod) {
            setIsLoading(true);
            const isValid = profileMod.companyManageResponses.filter((item) => item.companyUuid === id);
            if (isValid && isValid.length > 0) {

                if (isValid[0].companyStatus == "REGISTERED") {
                    setIsLoading(false);
                    localStorage.setItem(storage.company_uuid, id);
                    navigate("/" + id + "/register-company");
                } else {
                    getCompany(id).then((res) => {
                        console.log(res);
                        if (res.data.is_success) {
                            localStorage.setItem(storage.company_uuid, id);
                           

                            const profile = profileMod.companyManageResponses.filter((item) => item.companyUuid === id)[0];
                            profileMod.roleName = profile.roleName;
                            tokenService.setProfile(profileMod);
                            setProfileModel(profileMod);
                            setProfileMod(profileMod);
                            ScoutConnectService.getTeamManagement().then((res) => {
                                console.log(res);
                                if (res.data.content) {
                                    updateUser(id, res.data.content).then((res) => {
                                         setIsLoading(false);
                                        console.log(res);
                                        navigate("/" + id + "/job-questions-list");

                                    })
                                }

                            })

                        }
                    }).catch((err) => {
                        createCompany(id).then((res) => {
                            if (res.data) {
                               
                                localStorage.setItem(storage.company_uuid, id);
                                const profile = profileMod.companyManageResponses.filter((item) => item.companyUuid === id)[0];
                                profileMod.roleName = profile.roleName;
                                tokenService.setProfile(profileMod);
                                setProfileModel(profileMod);
                                setProfileMod(profileMod);
                                ScoutConnectService.getTeamManagement().then((res) => {
                                    console.log(res);
                                    if (res.data.content) {
                                        updateUser(id, res.data.content).then((res) => {
                                             setIsLoading(false);
                                            console.log(res);
                                            navigate("/" + id + "/job-questions-list");

                                        })
                                    }

                                })
                                navigate("/" + id + "/job-questions-list");
                            }
                        }).catch((err) => {
                            setIsLoading(false);
                            navigate("/login")
                        })

                    })

                }
            }
        }


    }
    return (
        <>
            <div className="choose-company-control">
                <img src={LOGO} className="logo-interview-ai"></img>
                {
                    isLoading ?
                        <div className="choose-company-content">
                            <div className="loading-control">
                                <Lottie animationData={LOADING} className="loading-progress"></Lottie>
                                <span className="text">กำลังตรวจสอบข้อมูล เพื่อเข้าสูู่ระบบของบริษัท</span>
                            </div>
                        </div> :
                        <div className="choose-company-content">
                            <span className="choose-company-title">เลือกบริษัทที่จะเข้าใช้งาน</span>

                            <div className="choose-company-list-item">
                                {
                                    profileMod && profileMod.companyManageResponses && profileMod.companyManageResponses.length > 0 &&
                                    profileMod.companyManageResponses.map((item, index) => {

                                        return (
                                            <>
                                                <div className="border-std choose-company-item" onClick={() => chooseCompany(item.companyUuid)}>
                                                    <div className="choose-company-item-control">

                                                        <img src={item.companyLogoImageUrl ? item.companyLogoImageUrl : ""} className="choose-company-img"></img>
                                                        <span className="choose-company-text">{item.companyName}</span>
                                                    </div>
                                                </div>

                                            </>



                                        )
                                    })
                                }
                            </div>
                        </div>
                }

            </div>
        </>
    )
}

export default ChooseCompanyComponent;